import { Capacitor, CapacitorHttp } from "@capacitor/core";
import _BaseAPIService from "../_BaseAPIService";
import { XMLParser } from "fast-xml-parser";

const apiService = _BaseAPIService.instance;

const CategoryServices = {
  listCategory: async (languageid = "1") => {
    try {
      const params = new URLSearchParams();
      params.append("languageid", languageid);

      let rawText;

      if (Capacitor.getPlatform() !== 'web') {
        // Native → CapacitorHttp bypasses CORS
        const response = await CapacitorHttp.post({
          url: `/Services/OrderWebservice.asmx/getGlobalizedMenu`,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          data: params.toString(),
        });

        // CapacitorHttp returns parsed JSON if possible, but here it's XML string
        rawText = typeof response.data === 'string' ? response.data : JSON.stringify(response.data);
      } else {
        // Web → fetch
        const response = await fetch(`/Services/OrderWebservice.asmx/getGlobalizedMenu`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: params.toString(),
        });
        console.log("🚀 ~ response:", response)

        rawText = await response.text();
        console.log("🚀 ~ rawText:", rawText)
      }

      // Parse XML to extract JSON string
      const parser = new XMLParser();
      const parsedXml = parser.parse(rawText);
      const innerText = parsedXml?.string || '';

      // Convert JSON string to JS object/array
      const jsonData = JSON.parse(innerText);

      return jsonData;
    } catch (error) {
      console.error('Error in listCategory:', error);
      throw error;
    }
  },

  categoryList: async () => {
    const response = await apiService.get("/category");
    return response.data;
  },
  subcategoryList: async ({ pageSize = 10, pageNumber = 1 }) => {
    const response = await apiService.get(
      `/category?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return response.data;
  },

  maincategoryList: async () => {
    const response = await apiService.get("/category");
    return response.data;
  },

  maincategory: async ({
    name = "",
    pageNumber = 1,
    pageSize = 1000,
    Status = null,
    showInOrder,
  } = {}) => {
    const params = new URLSearchParams({
      ...(name && { name }),
      Page: pageNumber.toString(),
      PageSize: pageSize.toString(),
      ...(showInOrder != null && { ShowInOrder: showInOrder }),
      ...(Status !== null && { Status: Status.toString() }),
    });

    const response = await apiService.get(`/category?${params.toString()}`);
    return response.data;
  },

  categorycreate: async (postData) => {
    try {
      const response = await apiService.post("/category", postData);
      return response.data;
    } catch (error) {
      console.error("Error creating:", error);
      throw error;
    }
  },
  viewcategory: async (id) => {
    const response = await apiService.get(`/category/${id}`);
    return response.data;
  },
  deletecategory: async (id) => {
    const response = await apiService.delete(`/category/${id}`);
    return response.data;
  },
  categoryUpdate: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/category/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  viewitems: async (id) => {
    const response = await apiService.get(`/items/itemdetail/${id}`);
    return response.data;
  },
};

export default CategoryServices;
